import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ScrollService } from '../../scroll.service';

@Component({
	selector: 'portals-qr-panel',
	templateUrl: './qr-panel.component.html',
	styleUrls: ['./qr-panel.component.scss'],
})
export class QrPanelComponent implements OnInit {
	@ViewChild('targetDiv') targetDiv!: ElementRef;

	constructor(private scrollService: ScrollService) {}
  
	ngOnInit() {
	  this.scrollService.scrollToTarget$.subscribe(() => {
		this.scrollToDiv();
	  });
	}
  
	scrollToDiv(): void {
	  this.targetDiv.nativeElement.scrollIntoView({ behavior: 'smooth' });
	}
}
